import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';

const Footer = () => {
    const isMobile = useMediaQuery('(max-width:768px)');
    const [showFull, setShowFull] = useState(false);
    const footerRef = useRef(null);

    // Close footer if click happens outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (footerRef.current && !footerRef.current.contains(e.target)) {
                setShowFull(false);
            }
        };
        if (isMobile) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => document.removeEventListener('click', handleClickOutside);
    }, [isMobile]);

    // Always show full on desktop
    useEffect(() => {
        if (!isMobile) setShowFull(true);
    }, [isMobile]);

    return (
        <Box
            component="footer"
            ref={footerRef}
            sx={{
                backgroundColor: '#f5f5f5',
                p: 1,
                textAlign: 'center',
                borderTop: '1px solid #ddd',
                fontSize: '0.7rem',
                cursor: isMobile ? 'pointer' : 'default',
                userSelect: 'none'
            }}
            onClick={(e) => {
                if (isMobile) {
                    e.stopPropagation(); // prevent collapse immediately after click
                    setShowFull(true);
                }
            }}
        >
            <Typography variant="caption" color="text.secondary">
                {isMobile && !showFull ? (
                    <>© 2025 Grind Analytics LLC • Click for Legal</>
                ) : (
                    <>
                        © 2025 Grind Analytics LLC. All rights reserved.{' '}
                        <a href="/terms" style={{ color: 'inherit', textDecoration: 'underline' }}>
                            Terms of Use
                        </a>{' '}
                        |{' '}
                        <a href="/privacy" style={{ color: 'inherit', textDecoration: 'underline' }}>
                            Privacy Policy
                        </a>
                    </>
                )}
            </Typography>
        </Box>
    );
};

export default Footer;
